import { cn } from "@/lib/utils"

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  showLabel?: boolean;
  label?: string;
}

function Skeleton({
  className,
  showLabel = false,
  label = "Caricamento...",
  ...props
}: SkeletonProps) {
  return (
    <div
      className={cn("skeleton relative", className)}
      role="status"
      aria-live="polite"
      aria-label={label}
      {...props}
    >
      {showLabel && (
        <span className="sr-only">{label}</span>
      )}
    </div>
  )
}

export { Skeleton }